module.exports = __webpack_public_path__ + "img/cart.5038aff9.svg";